import { Order } from "@redotech/redo-model/order";
import { ReactNode, createContext, memo } from "react";
import { useOrders } from "../hooks/orders-hooks";

interface OrdersContextType {
  orders: Order[] | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
  updateOrder: (updatedOrder: Order) => void;
}

export const OrdersContext = createContext<OrdersContextType | undefined>(
  undefined,
);

export const OrdersProvider = memo(function OrdersProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const ordersData = useOrders();

  return (
    <OrdersContext.Provider value={ordersData}>
      {children}
    </OrdersContext.Provider>
  );
});
